/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
// import useInput from '../hooks/useInput';

function Navigation({ onSignOut }) {
  // const [keyword, onKeywordChange] = useInput('');
  const navigate = useNavigate();

  const onLogoClick = () => {
    navigate('/');
  };

  return (
    <div className="navigation">
      <h1 style={{ cursor: 'pointer' }} role="button" onClick={onLogoClick}>Quantum</h1>
      <button type="button" onClick={() => onSignOut()}>
        Sign Out
      </button>
    </div>
  );
}

Navigation.propTypes = {
  onSignOut: PropTypes.func.isRequired,
};

export default Navigation;
